// import React, { useEffect, useState, useMemo, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchSemesterSummary } from "../../redux/actions/attendanceActions";
// import {
//   FiCalendar,
//   FiFilter,
//   FiSearch,
//   FiDownload,
//   FiPrinter,
//   FiUser,
//   FiTrendingUp,
//   FiTrendingDown,
//   FiCheckCircle,
//   FiXCircle,
//   FiBarChart2,
//   FiUsers,
//   FiBook,
//   FiChevronDown,
//   FiChevronUp,
//   FiChevronLeft,
//   FiChevronRight,
//   FiFileText,
//   FiAlertCircle,
//   FiX,
//   FiBriefcase,
//   FiHash,
// } from "react-icons/fi";
// import { toast } from "react-hot-toast";
// import * as XLSX from "xlsx";

// const SemesterWiseReports = () => {
//   const dispatch = useDispatch();

//   // State for filters
//   const [semester, setSemester] = useState("");
//   const [classType, setClassType] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [sortConfig, setSortConfig] = useState({
//     key: "present_percentage",
//     direction: "desc",
//   });

//   // Search state for student search
//   const [studentSearchTerm, setStudentSearchTerm] = useState("");
//   const [debouncedStudentSearchTerm, setDebouncedStudentSearchTerm] =
//     useState("");

//   // Debounce timeout ref
//   const debounceTimeoutRef = useRef(null);

//   // Semester options
//   const semesterOptions = [
//     { value: "", label: "Select Semester", disabled: true },
//     { value: "1", label: "Semester 1" },
//     { value: "2", label: "Semester 2" },
//     { value: "3", label: "Semester 3" },
//     { value: "4", label: "Semester 4" },
//     { value: "5", label: "Semester 5" },
//     { value: "6", label: "Semester 6" },
//     { value: "7", label: "Semester 7" },
//     { value: "8", label: "Semester 8" },
//   ];

//   // Get data from Redux
//   const { semesterSummary, loading, error } = useSelector(
//     (state) => state.attendance,
//   );

//   // Extract students data from API response (handles both 'data' and 'students' keys)
//   const getStudentsData = () => {
//     if (!semesterSummary) return [];
//     // Handle both possible response structures
//     if (semesterSummary.data && Array.isArray(semesterSummary.data)) {
//       return semesterSummary.data;
//     }
//     if (semesterSummary.students && Array.isArray(semesterSummary.students)) {
//       return semesterSummary.students;
//     }
//     return [];
//   };

//   // Extract summary data
//   const getSummaryData = () => {
//     if (!semesterSummary) return null;
//     return semesterSummary.summary || semesterSummary.summary_data || null;
//   };

//   // Extract pagination info
//   const getPaginationData = () => {
//     if (!semesterSummary) return null;
//     return semesterSummary.meta?.pagination || semesterSummary.pagination || null;
//   };

//   // Debounce search term - smooth typing without loading on every keystroke
//   useEffect(() => {
//     if (debounceTimeoutRef.current) {
//       clearTimeout(debounceTimeoutRef.current);
//     }

//     debounceTimeoutRef.current = setTimeout(() => {
//       setDebouncedStudentSearchTerm(studentSearchTerm);
//     }, 300);

//     return () => {
//       if (debounceTimeoutRef.current) {
//         clearTimeout(debounceTimeoutRef.current);
//       }
//     };
//   }, [studentSearchTerm]);

//   // Filtered students data based on search term - client-side filtering
//   const filteredStudents = useMemo(() => {
//     const students = getStudentsData();

//     if (!debouncedStudentSearchTerm.trim()) return students;

//     const searchLower = debouncedStudentSearchTerm.toLowerCase().trim();

//     return students.filter((student) => {
//       const studentNameMatch =
//         student.student_name?.toLowerCase().includes(searchLower) || false;
//       const studentIdMatch =
//         student.student_id?.toString().includes(searchLower) || false;
//       const clgRollMatch =
//         student.clg_roll?.toLowerCase().includes(searchLower) || false;
//       const programmeMatch =
//         student.programme_name?.toLowerCase().includes(searchLower) || false;
//       return studentNameMatch || studentIdMatch || clgRollMatch || programmeMatch;
//     });
//   }, [semesterSummary, debouncedStudentSearchTerm]);

//   // Calculate pagination for filtered data
//   const filteredPagination = useMemo(() => {
//     if (!filteredStudents || filteredStudents.length === 0) {
//       return { total: 0, totalPages: 0 };
//     }
//     return {
//       total: filteredStudents.length,
//       totalPages: Math.ceil(filteredStudents.length / limit),
//     };
//   }, [filteredStudents, limit]);

//   // Get current page data from filtered results
//   const currentFilteredStudents = useMemo(() => {
//     if (!filteredStudents || filteredStudents.length === 0) return [];
//     const startIndex = (currentPage - 1) * limit;
//     const endIndex = startIndex + limit;
//     return filteredStudents.slice(startIndex, endIndex);
//   }, [filteredStudents, currentPage, limit]);

//   // Reset to page 1 when search term changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [debouncedStudentSearchTerm]);

//   // Reset search when semester changes
//   useEffect(() => {
//     setStudentSearchTerm("");
//     setDebouncedStudentSearchTerm("");
//     setCurrentPage(1);
//   }, [semester]);

//   // Handle search
//   const handleSearch = () => {
//     if (!semester) {
//       toast.error("Please select a semester");
//       return;
//     }

//     setCurrentPage(1);
//     setStudentSearchTerm("");
//     setDebouncedStudentSearchTerm("");
//     dispatch(
//       fetchSemesterSummary({
//         sem: semester,
//         page: 1,
//         class_type: classType,
//         limit,
//       }),
//     );
//   };

//   // Handle reset
//   const handleReset = () => {
//     setSemester("");
//     setClassType("");
//     setCurrentPage(1);
//     setStudentSearchTerm("");
//     setDebouncedStudentSearchTerm("");
//     setSortConfig({ key: "present_percentage", direction: "desc" });
//   };

//   // Handle page change
//   const handlePageChange = (newPage) => {
//     if (newPage < 1 || newPage > (filteredPagination?.totalPages || 1)) return;
//     setCurrentPage(newPage);
//   };

//   // Handle limit change
//   const handleLimitChange = (newLimit) => {
//     setLimit(newLimit);
//     setCurrentPage(1);
//   };

//   // Handle sorting
//   const handleSort = (key) => {
//     setSortConfig({
//       key,
//       direction:
//         sortConfig.key === key && sortConfig.direction === "asc"
//           ? "desc"
//           : "asc",
//     });
//   };

//   // Sort filtered students
//   const sortedFilteredStudents = useMemo(() => {
//     return [...currentFilteredStudents].sort((a, b) => {
//       let aValue = a[sortConfig.key];
//       let bValue = b[sortConfig.key];

//       if (sortConfig.key === "present_percentage") {
//         aValue = parseFloat(aValue);
//         bValue = parseFloat(bValue);
//       }

//       if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
//       if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
//       return 0;
//     });
//   }, [currentFilteredStudents, sortConfig]);

//   // Export to Excel
//   const handleExportToExcel = () => {
//     if (!semester || !filteredStudents.length) {
//       toast.error("No data to export");
//       return;
//     }

//     try {
//       const exportData = filteredStudents.map((student) => ({
//         "Rank": student.rank || "",
//         "Student ID": student.student_id,
//         "Student Name": student.student_name,
//         "College Roll": student.clg_roll || "",
//         "Programme Name": student.programme_name || "",
//         "Total Classes": student.total_class,
//         Present: student.present,
//         Absent: student.absent,
//         "Attendance Percentage": student.present_percentage,
//         Status: getAttendanceStatus(student.present_percentage).label,
//         Semester: semester,
//       }));

//       const stats = calculateStats();
//       if (stats) {
//         exportData.push(
//           {},
//           {
//             "Student Name": "SUMMARY",
//             "Total Students": stats.totalStudents,
//             "Total Classes": stats.totalClasses,
//             "Overall Attendance": stats.overallAttendance,
//             "Good Attendance (≥75%)": stats.goodAttendance,
//             "Average Attendance (50-74%)": stats.averageAttendance,
//             "Poor Attendance (<50%)": stats.poorAttendance,
//           },
//         );
//       }

//       const worksheet = XLSX.utils.json_to_sheet(exportData);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(
//         workbook,
//         worksheet,
//         `Semester ${semester} Attendance`,
//       );

//       // Auto-size columns
//       const wscols = [
//         { wch: 8 },  // Rank
//         { wch: 12 }, // Student ID
//         { wch: 25 }, // Student Name
//         { wch: 18 }, // College Roll
//         { wch: 35 }, // Programme Name
//         { wch: 14 }, // Total Classes
//         { wch: 10 }, // Present
//         { wch: 10 }, // Absent
//         { wch: 18 }, // Attendance Percentage
//         { wch: 10 }, // Status
//         { wch: 10 }, // Semester
//       ];
//       worksheet['!cols'] = wscols;

//       const fileName = `Semester_${semester}_Attendance_Report_${new Date().toISOString().split("T")[0]}.xlsx`;
//       XLSX.writeFile(workbook, fileName);
//       toast.success(`Report exported successfully as ${fileName}`);
//     } catch (error) {
//       console.error("Export error:", error);
//       toast.error("Failed to export report");
//     }
//   };

//   // Export to CSV
//   const handleExportToCSV = () => {
//     if (!semester || !filteredStudents.length) {
//       toast.error("No data to export");
//       return;
//     }

//     try {
//       const headers = [
//         "Rank,Student ID,Student Name,College Roll,Programme Name,Total Classes,Present,Absent,Attendance Percentage,Status,Semester"
//       ];

//       const rows = filteredStudents.map((student) => {
//         const status = getAttendanceStatus(student.present_percentage).label;
//         return `${student.rank || ""},${student.student_id},"${student.student_name}",${student.clg_roll || ""},"${student.programme_name || ""}",${student.total_class},${student.present},${student.absent},${student.present_percentage},${status},${semester}`;
//       });

//       const stats = calculateStats();
//       if (stats) {
//         rows.push("");
//         rows.push('"SUMMARY",,,,,,,,');
//         rows.push(`"Total Students",${stats.totalStudents}`);
//         rows.push(`"Total Classes",${stats.totalClasses}`);
//         rows.push(`"Overall Attendance","${stats.overallAttendance}"`);
//         rows.push(`"Good Attendance (≥75%)",${stats.goodAttendance}`);
//         rows.push(`"Average Attendance (50-74%)",${stats.averageAttendance}`);
//         rows.push(`"Poor Attendance (<50%)",${stats.poorAttendance}`);
//       }

//       const csvContent = [...headers, ...rows].join("\n");
//       const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       const url = URL.createObjectURL(blob);

//       link.setAttribute("href", url);
//       link.setAttribute(
//         "download",
//         `Semester_${semester}_Attendance_Report_${new Date().toISOString().split("T")[0]}.csv`,
//       );
//       link.style.visibility = "hidden";

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       toast.success(`Report exported successfully as CSV`);
//     } catch (error) {
//       console.error("CSV export error:", error);
//       toast.error("Failed to export CSV report");
//     }
//   };

//   const students = sortedFilteredStudents;
//   const pagination = filteredPagination;
//   const summary = getSummaryData();

//   // Calculate statistics from filtered data
//   const calculateStats = () => {
//     if (!filteredStudents.length) return null;

//     const presentClasses = filteredStudents.reduce(
//       (sum, s) => sum + (s.present || 0),
//       0,
//     );
//     const totalClasses = filteredStudents.reduce(
//       (sum, s) => sum + (s.total_class || 0),
//       0,
//     );
//     const overallAttendance =
//       totalClasses > 0 ? (presentClasses / totalClasses) * 100 : 0;

//     const perfectAttendance = filteredStudents.filter(
//       (s) => s.present_percentage === "100.00%",
//     ).length;
//     const goodAttendance = filteredStudents.filter(
//       (s) => parseFloat(s.present_percentage) >= 75,
//     ).length;
//     const averageAttendance = filteredStudents.filter(
//       (s) =>
//         parseFloat(s.present_percentage) >= 50 &&
//         parseFloat(s.present_percentage) < 75,
//     ).length;
//     const poorAttendance = filteredStudents.filter(
//       (s) => parseFloat(s.present_percentage) < 50,
//     ).length;

//     return {
//       totalStudents: filteredStudents.length,
//       totalClasses,
//       overallAttendance: overallAttendance.toFixed(2) + "%",
//       perfectAttendance,
//       goodAttendance,
//       averageAttendance,
//       poorAttendance,
//       attendanceTrend:
//         overallAttendance > 75
//           ? "up"
//           : overallAttendance > 50
//             ? "stable"
//             : "down",
//     };
//   };

//   const stats = calculateStats();

//   // Get attendance status
//   const getAttendanceStatus = (percentage) => {
//     const percent = parseFloat(percentage);
//     if (percent >= 75)
//       return {
//         label: "Good",
//         color: "green",
//         bg: "bg-green-100 dark:bg-green-900/30",
//         text: "text-green-800 dark:text-green-300",
//       };
//     if (percent >= 50)
//       return {
//         label: "Average",
//         color: "yellow",
//         bg: "bg-yellow-100 dark:bg-yellow-900/30",
//         text: "text-yellow-800 dark:text-yellow-300",
//       };
//     return {
//       label: "Poor",
//       color: "red",
//       bg: "bg-red-100 dark:bg-red-900/30",
//       text: "text-red-800 dark:text-red-300",
//     };
//   };

//   // Get attendance color
//   const getAttendanceColor = (percentage) => {
//     const percent = parseFloat(percentage);
//     if (percent >= 75) return "text-green-600 dark:text-green-400";
//     if (percent >= 50) return "text-yellow-600 dark:text-yellow-400";
//     return "text-red-600 dark:text-red-400";
//   };

//   // Get attendance bar color
//   const getAttendanceBarColor = (percentage) => {
//     const percent = parseFloat(percentage);
//     if (percent >= 75) return "bg-green-500";
//     if (percent >= 50) return "bg-yellow-500";
//     return "bg-red-500";
//   };

//   // Handle print
//   const handlePrint = () => {
//     if (!semester) {
//       toast.error("Please select a semester first");
//       return;
//     }
//     window.print();
//   };

//   return (
//     <div className="p-6 space-y-6">
//       {/* Header Section */}
//       <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
//         <div>
//           <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">
//             Semester Wise Attendance Report
//           </h1>
//           <p className="text-gray-600 dark:text-gray-300 mt-1">
//             Analyze attendance data for each semester with comprehensive
//             insights
//           </p>
//         </div>
//         <div className="flex items-center gap-3">
//           {/* Export Dropdown */}
//           <div className="relative group">
//             <button
//               disabled={!semester || !filteredStudents.length}
//               className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-lg ${
//                 semester && filteredStudents.length
//                   ? "bg-green-600 hover:bg-green-700 text-white"
//                   : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
//               }`}
//             >
//               <FiDownload className="w-4 h-4" />
//               <span className="hidden sm:inline">Export</span>
//             </button>
//             <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-10">
//               <button
//                 onClick={handleExportToExcel}
//                 disabled={!semester || !filteredStudents.length}
//                 className="w-full text-left px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 flex items-center gap-2 text-gray-700 dark:text-gray-300"
//               >
//                 <FiFileText className="w-4 h-4" />
//                 Export as Excel
//               </button>
//               <button
//                 onClick={handleExportToCSV}
//                 disabled={!semester || !filteredStudents.length}
//                 className="w-full text-left px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 flex items-center gap-2 text-gray-700 dark:text-gray-300"
//               >
//                 <FiFileText className="w-4 h-4" />
//                 Export as CSV
//               </button>
//             </div>
//           </div>

//           <button
//             onClick={handlePrint}
//             disabled={!semester}
//             className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-lg ${
//               semester
//                 ? "bg-blue-600 hover:bg-blue-700 text-white"
//                 : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
//             }`}
//           >
//             <FiPrinter className="w-4 h-4" />
//             <span className="hidden sm:inline">Print</span>
//           </button>
//         </div>
//       </div>

//       {/* Filters Card */}
//       <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700">
//         <div className="flex items-center gap-3 mb-6">
//           <FiFilter className="w-6 h-6 text-purple-600 dark:text-purple-400" />
//           <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
//             Semester Selection
//           </h2>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//           {/* Semester Select */}
//           <div className="relative group">
//             <div className="absolute left-4 top-4 text-gray-400">
//               <FiBook className="w-5 h-5" />
//             </div>
//             <select
//               className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 focus:outline-none transition-all duration-300 group-hover:border-purple-400"
//               value={semester}
//               onChange={(e) => setSemester(e.target.value)}
//             >
//               {semesterOptions.map((option) => (
//                 <option
//                   key={option.value}
//                   value={option.value}
//                   disabled={option.disabled}
//                 >
//                   {option.label}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Class Type Filter */}
//           <div className="relative group">
//             <div className="absolute left-4 top-4 text-gray-400">
//               <FiFilter className="w-5 h-5" />
//             </div>
//             <select
//               className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 focus:outline-none transition-all duration-300 group-hover:border-purple-400"
//               value={classType}
//               onChange={(e) => setClassType(e.target.value)}
//             >
//               <option value="">All Class Types</option>
//               <option value="Theory">Theory</option>
//               <option value="Practical">Practical</option>
//               <option value="Tutorial">Tutorial</option>
//             </select>
//           </div>

//           {/* Action Buttons */}
//           <div className="flex gap-3 md:col-span-2">
//             <button
//               onClick={handleSearch}
//               disabled={loading || !semester}
//               className={`flex-1 flex items-center justify-center gap-2 font-semibold py-3 px-6 rounded-xl transition-all duration-300 hover:shadow-lg ${
//                 semester
//                   ? "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white"
//                   : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
//               }`}
//             >
//               {loading ? (
//                 <>
//                   <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                   <span>Loading...</span>
//                 </>
//               ) : (
//                 <>
//                   <FiSearch className="w-5 h-5" />
//                   <span>Generate Report</span>
//                 </>
//               )}
//             </button>
//             <button
//               onClick={handleReset}
//               className="px-4 py-3 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-medium rounded-xl transition-all duration-300"
//             >
//               Reset
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Search Bar - Student Search */}
//       {semester && getStudentsData().length > 0 && (
//         <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700">
//           <div className="relative group">
//             <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
//               <FiSearch className="w-5 h-5" />
//             </div>
//             <input
//               type="text"
//               placeholder="Search by Name, ID, College Roll, or Programme..."
//               value={studentSearchTerm}
//               onChange={(e) => setStudentSearchTerm(e.target.value)}
//               className="w-full pl-12 pr-12 py-3 rounded-xl border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 focus:outline-none transition-all duration-300 group-hover:border-purple-400 text-base"
//               autoComplete="off"
//             />
//             {studentSearchTerm && (
//               <button
//                 onClick={() => {
//                   setStudentSearchTerm("");
//                   setDebouncedStudentSearchTerm("");
//                 }}
//                 className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
//               >
//                 <FiX className="w-5 h-5" />
//               </button>
//             )}
//           </div>
//           {debouncedStudentSearchTerm &&
//             filteredStudents.length === 0 &&
//             getStudentsData().length > 0 && (
//               <p className="mt-2 text-sm text-amber-600 dark:text-amber-400 flex items-center gap-1">
//                 <FiAlertCircle className="w-4 h-4" />
//                 No students found matching "{debouncedStudentSearchTerm}"
//               </p>
//             )}
//           {debouncedStudentSearchTerm && filteredStudents.length > 0 && (
//             <p className="mt-2 text-sm text-green-600 dark:text-green-400">
//               Found {filteredStudents.length} student
//               {filteredStudents.length !== 1 ? "s" : ""} matching "
//               {debouncedStudentSearchTerm}"
//             </p>
//           )}
//         </div>
//       )}

//       {/* Statistics Cards */}
//       {semester && stats && (
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//           {/* Overall Stats */}
//           <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-2xl shadow p-6 border border-purple-200 dark:border-purple-800">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-600 dark:text-gray-400">
//                   Overall Attendance
//                 </p>
//                 <p className="text-3xl font-bold text-gray-900 dark:text-white mt-2">
//                   {stats.overallAttendance}
//                 </p>
//                 <div className="flex items-center gap-2 mt-2">
//                   <span
//                     className={`text-sm font-medium ${
//                       stats.attendanceTrend === "up"
//                         ? "text-green-600 dark:text-green-400"
//                         : stats.attendanceTrend === "stable"
//                           ? "text-yellow-600 dark:text-yellow-400"
//                           : "text-red-600 dark:text-red-400"
//                     }`}
//                   >
//                     {stats.attendanceTrend === "up"
//                       ? "Good"
//                       : stats.attendanceTrend === "stable"
//                         ? "Average"
//                         : "Needs Improvement"}
//                   </span>
//                   {stats.attendanceTrend === "up" ? (
//                     <FiTrendingUp className="w-4 h-4 text-green-500" />
//                   ) : stats.attendanceTrend === "stable" ? (
//                     <FiBarChart2 className="w-4 h-4 text-yellow-500" />
//                   ) : (
//                     <FiTrendingDown className="w-4 h-4 text-red-500" />
//                   )}
//                 </div>
//               </div>
//               <div className="p-3 bg-white dark:bg-gray-800 rounded-full shadow">
//                 <FiBarChart2 className="w-8 h-8 text-purple-600 dark:text-purple-400" />
//               </div>
//             </div>
//             <div className="mt-4 pt-4 border-t border-purple-200 dark:border-purple-800">
//               <p className="text-sm text-gray-600 dark:text-gray-400">
//                 Based on {stats.totalStudents} students across{" "}
//                 {stats.totalClasses} classes
//               </p>
//             </div>
//           </div>

//           {/* Total Students */}
//           <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6 border border-gray-200 dark:border-gray-700">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-500 dark:text-gray-400">
//                   Total Students
//                 </p>
//                 <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
//                   {stats.totalStudents}
//                 </p>
//               </div>
//               <div className="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-full">
//                 <FiUsers className="w-6 h-6 text-blue-600 dark:text-blue-400" />
//               </div>
//             </div>
//           </div>

//           {/* Good Attendance */}
//           <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6 border border-gray-200 dark:border-gray-700">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-500 dark:text-gray-400">
//                   Good Attendance (≥75%)
//                 </p>
//                 <p className="text-2xl font-bold text-green-600 dark:text-green-400 mt-1">
//                   {stats.goodAttendance}
//                 </p>
//                 <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
//                   {stats.totalStudents > 0
//                     ? (
//                         (stats.goodAttendance / stats.totalStudents) *
//                         100
//                       ).toFixed(1)
//                     : 0}
//                   % of total
//                 </p>
//               </div>
//               <div className="p-3 bg-green-100 dark:bg-green-900/30 rounded-full">
//                 <FiCheckCircle className="w-6 h-6 text-green-600 dark:text-green-400" />
//               </div>
//             </div>
//           </div>

//           {/* Poor Attendance */}
//           <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6 border border-gray-200 dark:border-gray-700">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-500 dark:text-gray-400">
//                   Poor Attendance (&lt;50%)
//                 </p>
//                 <p className="text-2xl font-bold text-red-600 dark:text-red-400 mt-1">
//                   {stats.poorAttendance}
//                 </p>
//                 <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
//                   {stats.totalStudents > 0
//                     ? (
//                         (stats.poorAttendance / stats.totalStudents) *
//                         100
//                       ).toFixed(1)
//                     : 0}
//                   % of total
//                 </p>
//               </div>
//               <div className="p-3 bg-red-100 dark:bg-red-900/30 rounded-full">
//                 <FiXCircle className="w-6 h-6 text-red-600 dark:text-red-400" />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Semester Info Card */}
//       {semester && semesterSummary && (
//         <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700">
//           <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
//             <div>
//               <h3 className="text-xl font-bold text-gray-900 dark:text-white">
//                 Semester {semester} Attendance Summary
//               </h3>
//               <p className="text-gray-600 dark:text-gray-300 mt-1">
//                 Detailed attendance analysis for all students
//               </p>
//             </div>
//             <div className="flex items-center gap-4">
//               <div className="bg-gray-100 dark:bg-gray-900 px-4 py-2 rounded-lg">
//                 <div className="text-center">
//                   <div className="text-2xl font-bold text-purple-600 dark:text-purple-400">
//                     {summary?.total_class || 0}
//                   </div>
//                   <div className="text-sm text-gray-600 dark:text-gray-400">
//                     Total Classes
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Results Table */}
//       <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700">
//         {/* Table Header */}
//         <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
//           <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
//             <div>
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 Student Attendance Details
//               </h3>
//               <div className="flex items-center gap-4 mt-2 text-sm">
//                 <button
//                   onClick={() => handleSort("student_name")}
//                   className="flex items-center gap-1 text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 transition-colors duration-200"
//                 >
//                   Sort by Name
//                   {sortConfig.key === "student_name" &&
//                     (sortConfig.direction === "asc" ? (
//                       <FiChevronUp className="w-4 h-4" />
//                     ) : (
//                       <FiChevronDown className="w-4 h-4" />
//                     ))}
//                 </button>
//                 <button
//                   onClick={() => handleSort("present_percentage")}
//                   className="flex items-center gap-1 text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 transition-colors duration-200"
//                 >
//                   Sort by Attendance
//                   {sortConfig.key === "present_percentage" &&
//                     (sortConfig.direction === "asc" ? (
//                       <FiChevronUp className="w-4 h-4" />
//                     ) : (
//                       <FiChevronDown className="w-4 h-4" />
//                     ))}
//                 </button>
//               </div>
//             </div>

//             {/* Pagination Controls - Top */}
//             {pagination.totalPages > 0 && (
//               <div className="flex items-center gap-4">
//                 <div className="flex items-center gap-2">
//                   <span className="text-sm text-gray-600 dark:text-gray-400">
//                     Show
//                   </span>
//                   <select
//                     value={limit}
//                     onChange={(e) => handleLimitChange(Number(e.target.value))}
//                     className="px-2 py-1 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm"
//                   >
//                     <option value="5">5</option>
//                     <option value="10">10</option>
//                     <option value="25">25</option>
//                     <option value="50">50</option>
//                     <option value="100">100</option>
//                     <option value="500">500</option>
//                     <option value="1000">1000</option>
//                     <option value="2000">2000</option>
//                   </select>
//                   <span className="text-sm text-gray-600 dark:text-gray-400">
//                     entries
//                   </span>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Table */}
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-50 dark:bg-gray-900/50">
//               <tr>
//                 <th className="py-4 px-6 text-left text-sm font-semibold text-gray-900 dark:text-white">
//                   Student Details
//                 </th>
//                 <th className="py-4 px-6 text-left text-sm font-semibold text-gray-900 dark:text-white">
//                   Programme
//                 </th>
//                 <th className="py-4 px-6 text-center text-sm font-semibold text-gray-900 dark:text-white">
//                   Attendance Summary
//                 </th>
//                 <th className="py-4 px-6 text-center text-sm font-semibold text-gray-900 dark:text-white">
//                   Class Type
//                 </th>
//                 <th className="py-4 px-6 text-center text-sm font-semibold text-gray-900 dark:text-white">
//                   Remarks
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
//               {loading ? (
//                 <tr>
//                   <td colSpan="5" className="py-12 text-center">
//                     <div className="flex flex-col items-center justify-center gap-3">
//                       <div className="w-12 h-12 border-4 border-purple-200 dark:border-purple-800 border-t-purple-600 dark:border-t-purple-400 rounded-full animate-spin"></div>
//                       <p className="text-gray-600 dark:text-gray-400">
//                         Loading semester data...
//                       </p>
//                     </div>
//                   </td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan="5" className="py-12 text-center">
//                     <div className="flex flex-col items-center justify-center gap-3">
//                       <div className="p-3 bg-red-100 dark:bg-red-900/20 rounded-full">
//                         <FiXCircle className="w-8 h-8 text-red-600 dark:text-red-400" />
//                       </div>
//                       <p className="text-red-600 dark:text-red-400 font-medium">
//                         {error}
//                       </p>
//                       <button
//                         onClick={handleSearch}
//                         className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors duration-300"
//                       >
//                         Try Again
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ) : !semester ? (
//                 <tr>
//                   <td colSpan="5" className="py-16 text-center">
//                     <div className="flex flex-col items-center justify-center gap-4">
//                       <div className="p-4 bg-purple-100 dark:bg-purple-900/20 rounded-full">
//                         <FiBook className="w-12 h-12 text-purple-600 dark:text-purple-400" />
//                       </div>
//                       <div>
//                         <p className="text-lg font-medium text-gray-900 dark:text-white mb-1">
//                           Select a Semester
//                         </p>
//                         <p className="text-gray-600 dark:text-gray-400">
//                           Please select a semester and click "Generate Report"
//                           to view attendance data
//                         </p>
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ) : students.length > 0 ? (
//                 students.map((student, index) => {
//                   const status = getAttendanceStatus(
//                     student.present_percentage,
//                   );
//                   const attendanceColor = getAttendanceColor(
//                     student.present_percentage,
//                   );
//                   const barColor = getAttendanceBarColor(
//                     student.present_percentage,
//                   );

//                   return (
//                     <tr
//                       key={student.student_id || index}
//                       className="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors duration-200"
//                     >
//                       <td className="py-4 px-6">
//                         <div className="flex items-center gap-3">
//                           <div className="w-10 h-10 bg-gradient-to-r from-purple-100 to-pink-100 dark:from-purple-900/30 dark:to-pink-900/30 rounded-full flex items-center justify-center">
//                             <FiUser className="w-5 h-5 text-purple-600 dark:text-purple-400" />
//                           </div>
//                           <div>
//                             <p className="font-medium text-gray-900 dark:text-white">
//                               {student.student_name}
//                             </p>
//                             <p className="text-sm text-gray-500 dark:text-gray-400">
//                               ID: {student.student_id} | Roll: {student.clg_roll || "N/A"}
//                             </p>
//                             {student.rank && (
//                               <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
//                                 Rank: #{student.rank}
//                               </p>
//                             )}
//                           </div>
//                         </div>
//                       </td>

//                       {/* Programme Name Column */}
//                       <td className="py-4 px-6">
//                         <div className="flex items-center gap-2">
//                           <FiBriefcase className="w-4 h-4 text-gray-400 dark:text-gray-500" />
//                           <span className="text-sm text-gray-700 dark:text-gray-300">
//                             {student.programme_name || "N/A"}
//                           </span>
//                         </div>
//                       </td>

//                       <td className="py-4 px-6">
//                         <div className="flex flex-col gap-3">
//                           {/* Progress Bar */}
//                           <div className="flex items-center justify-between">
//                             <span className="text-sm text-gray-600 dark:text-gray-400">
//                               Attendance
//                             </span>
//                             <span
//                               className={`text-lg font-bold ${attendanceColor}`}
//                             >
//                               {student.present_percentage}
//                             </span>
//                           </div>
//                           <div className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
//                             <div
//                               className={`h-full rounded-full ${barColor}`}
//                               style={{
//                                 width: `${Math.min(parseFloat(student.present_percentage), 100)}%`,
//                               }}
//                             ></div>
//                           </div>

//                           {/* Attendance Stats */}
//                           <div className="grid grid-cols-3 gap-2 text-center">
//                             <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded">
//                               <p className="text-sm text-gray-600 dark:text-gray-400">
//                                 Total
//                               </p>
//                               <p className="font-bold text-gray-900 dark:text-white">
//                                 {student.total_class}
//                               </p>
//                             </div>
//                             <div className="p-2 bg-green-50 dark:bg-green-900/20 rounded">
//                               <p className="text-sm text-gray-600 dark:text-gray-400">
//                                 Present
//                               </p>
//                               <p className="font-bold text-green-600 dark:text-green-400">
//                                 {student.present}
//                               </p>
//                             </div>
//                             <div className="p-2 bg-red-50 dark:bg-red-900/20 rounded">
//                               <p className="text-sm text-gray-600 dark:text-gray-400">
//                                 Absent
//                               </p>
//                               <p className="font-bold text-red-600 dark:text-red-400">
//                                 {student.absent}
//                               </p>
//                             </div>
//                           </div>
//                         </div>
//                       </td>

//                       {/* Class Type column */}
//                       <td className="py-4 px-6 text-center">
//                         <span
//                           className={`px-3 py-1 rounded-full text-sm font-medium ${
//                             summary?.class_type?.toLowerCase() === "theory"
//                               ? "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300"
//                               : summary?.class_type?.toLowerCase() === "practical"
//                                 ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
//                                 : summary?.class_type?.toLowerCase() === "tutorial"
//                                   ? "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300"
//                                   : "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300"
//                           }`}
//                         >
//                           {summary?.class_type
//                             ? summary.class_type.charAt(0).toUpperCase() +
//                               summary.class_type.slice(1).toLowerCase()
//                             : "N/A"}
//                         </span>
//                       </td>

//                       <td className="py-4 px-6 text-center">
//                         <div className="flex flex-col items-center gap-2">
//                           <span
//                             className={`px-3 py-1 rounded-full text-sm font-medium ${
//                               parseFloat(student.present_percentage) >= 60
//                                 ? "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300"
//                                 : "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300"
//                             }`}
//                           >
//                             {parseFloat(student.present_percentage) >= 60
//                               ? "Allowed"
//                               : "Not Allowed"}
//                           </span>
//                           <div className="flex items-center gap-1">
//                             {parseFloat(student.present_percentage) >= 60 ? (
//                               <FiCheckCircle className="w-4 h-4 text-green-500" />
//                             ) : (
//                               <FiXCircle className="w-4 h-4 text-red-500" />
//                             )}
//                             <span className="text-xs text-gray-500 dark:text-gray-400">
//                               {parseFloat(student.present_percentage) >= 60
//                                 ? "Attendance requirement met"
//                                 : "Below 60% requirement"}
//                             </span>
//                           </div>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="5" className="py-16 text-center">
//                     <div className="flex flex-col items-center justify-center gap-4">
//                       <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-full">
//                         <FiUsers className="w-12 h-12 text-gray-400 dark:text-gray-600" />
//                       </div>
//                       <div>
//                         <p className="text-lg font-medium text-gray-900 dark:text-white mb-1">
//                           {debouncedStudentSearchTerm
//                             ? "No matching students found"
//                             : "No student records found"}
//                         </p>
//                         <p className="text-gray-600 dark:text-gray-400">
//                           {debouncedStudentSearchTerm
//                             ? `No students found matching "${debouncedStudentSearchTerm}"`
//                             : `No attendance data available for Semester ${semester}`}
//                         </p>
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination Footer */}
//         {pagination.totalPages > 0 && (
//           <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
//             <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//               <div className="text-sm text-gray-500 dark:text-gray-400">
//                 Showing {(currentPage - 1) * limit + 1} to{" "}
//                 {Math.min(currentPage * limit, pagination.total || 0)} of{" "}
//                 {pagination.total || 0} records
//               </div>
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={() => handlePageChange(currentPage - 1)}
//                   disabled={currentPage === 1}
//                   className={`flex items-center gap-1 px-3 py-2 rounded-lg transition ${
//                     currentPage === 1
//                       ? "bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed"
//                       : "bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300"
//                   }`}
//                 >
//                   <FiChevronLeft />
//                   Previous
//                 </button>
//                 <div className="flex items-center gap-1">
//                   {Array.from(
//                     { length: Math.min(5, pagination.totalPages || 1) },
//                     (_, i) => {
//                       let pageNum;
//                       if (pagination.totalPages <= 5) {
//                         pageNum = i + 1;
//                       } else if (currentPage <= 3) {
//                         pageNum = i + 1;
//                       } else if (currentPage >= pagination.totalPages - 2) {
//                         pageNum = pagination.totalPages - 4 + i;
//                       } else {
//                         pageNum = currentPage - 2 + i;
//                       }

//                       if (pageNum < 1 || pageNum > pagination.totalPages)
//                         return null;

//                       return (
//                         <button
//                           key={pageNum}
//                           onClick={() => handlePageChange(pageNum)}
//                           className={`w-10 h-10 rounded-lg transition ${
//                             currentPage === pageNum
//                               ? "bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg"
//                               : "bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300"
//                           }`}
//                         >
//                           {pageNum}
//                         </button>
//                       );
//                     },
//                   )}
//                 </div>
//                 <button
//                   onClick={() => handlePageChange(currentPage + 1)}
//                   disabled={currentPage === pagination.totalPages}
//                   className={`flex items-center gap-1 px-3 py-2 rounded-lg transition ${
//                     currentPage === pagination.totalPages
//                       ? "bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed"
//                       : "bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300"
//                   }`}
//                 >
//                   Next
//                   <FiChevronRight />
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SemesterWiseReports;
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSemesterSummary } from "../../redux/actions/attendanceActions";
import {
  FiCalendar,
  FiFilter,
  FiSearch,
  FiDownload,
  FiPrinter,
  FiUser,
  FiTrendingUp,
  FiTrendingDown,
  FiCheckCircle,
  FiXCircle,
  FiBarChart2,
  FiUsers,
  FiBook,
  FiChevronDown,
  FiChevronUp,
  FiChevronLeft,
  FiChevronRight,
  FiFileText,
  FiAlertCircle,
  FiX,
  FiBriefcase,
} from "react-icons/fi";
import { toast } from "react-hot-toast";
import * as XLSX from "xlsx";

const SemesterWiseReports = () => {
  const dispatch = useDispatch();

  // --------------- STATE ---------------
  const [semester, setSemester] = useState("");
  const [classType, setClassType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortConfig, setSortConfig] = useState({
    key: "present_percentage",
    direction: "desc",
  });

  const [studentSearchTerm, setStudentSearchTerm] = useState("");
  const [debouncedStudentSearchTerm, setDebouncedStudentSearchTerm] = useState("");
  const debounceTimeoutRef = useRef(null);

  // --------------- OPTIONS ---------------
  const semesterOptions = [
    { value: "", label: "Select Semester", disabled: true },
    { value: "1", label: "Semester 1" },
    { value: "2", label: "Semester 2" },
    { value: "3", label: "Semester 3" },
    { value: "4", label: "Semester 4" },
    { value: "5", label: "Semester 5" },
    { value: "6", label: "Semester 6" },
    { value: "7", label: "Semester 7" },
    { value: "8", label: "Semester 8" },
  ];

  // --------------- REDUX ---------------
  const { semesterSummary, loading, error } = useSelector(
    (state) => state.attendance,
  );

  // --------------- DERIVED DATA ---------------
  const getStudentsData = () => {
    if (!semesterSummary) return [];
    if (semesterSummary.data && Array.isArray(semesterSummary.data)) return semesterSummary.data;
    if (semesterSummary.students && Array.isArray(semesterSummary.students)) return semesterSummary.students;
    return [];
  };

  const getSummaryData = () => {
    if (!semesterSummary) return null;
    return semesterSummary.summary || semesterSummary.summary_data || null;
  };

  const getPaginationData = () => {
    if (!semesterSummary) return null;
    return semesterSummary.meta?.pagination || semesterSummary.pagination || null;
  };

  // --------------- DEBOUNCE SEARCH ---------------
  useEffect(() => {
    if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
    debounceTimeoutRef.current = setTimeout(() => {
      setDebouncedStudentSearchTerm(studentSearchTerm);
    }, 300);
    return () => {
      if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
    };
  }, [studentSearchTerm]);

  // --------------- FILTERING & PAGINATION ---------------
  const filteredStudents = useMemo(() => {
    const students = getStudentsData();
    if (!debouncedStudentSearchTerm.trim()) return students;
    const searchLower = debouncedStudentSearchTerm.toLowerCase().trim();
    return students.filter((student) => {
      const nameMatch = student.student_name?.toLowerCase().includes(searchLower) || false;
      const idMatch = student.student_id?.toString().includes(searchLower) || false;
      const rollMatch = student.clg_roll?.toLowerCase().includes(searchLower) || false;
      const progMatch = student.programme_name?.toLowerCase().includes(searchLower) || false;
      return nameMatch || idMatch || rollMatch || progMatch;
    });
  }, [semesterSummary, debouncedStudentSearchTerm]);

  const filteredPagination = useMemo(() => {
    if (!filteredStudents?.length) return { total: 0, totalPages: 0 };
    return {
      total: filteredStudents.length,
      totalPages: Math.ceil(filteredStudents.length / limit),
    };
  }, [filteredStudents, limit]);

  const currentFilteredStudents = useMemo(() => {
    if (!filteredStudents?.length) return [];
    const startIndex = (currentPage - 1) * limit;
    return filteredStudents.slice(startIndex, startIndex + limit);
  }, [filteredStudents, currentPage, limit]);

  // Reset page on filter/search changes
  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedStudentSearchTerm, semester, fromDate, toDate, classType]);

  useEffect(() => {
    setStudentSearchTerm("");
    setDebouncedStudentSearchTerm("");
  }, [semester]);

  // --------------- ACTIONS ---------------
  const handleSearch = () => {
    if (!semester) {
      toast.error("Please select a semester");
      return;
    }
    setCurrentPage(1);
    setStudentSearchTerm("");
    setDebouncedStudentSearchTerm("");

    const payload = {
      sem: semester,
      page: 1,
      limit,
      class_type: classType,
    };
    if (fromDate) payload.from_date = fromDate;
    if (toDate) payload.to_date = toDate;

    dispatch(fetchSemesterSummary(payload));
  };

  const handleReset = () => {
    setSemester("");
    setClassType("");
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
    setStudentSearchTerm("");
    setDebouncedStudentSearchTerm("");
    setSortConfig({ key: "present_percentage", direction: "desc" });
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > (filteredPagination?.totalPages || 1)) return;
    setCurrentPage(newPage);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction:
        sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc",
    });
  };

  // --------------- SORTING ---------------
  const sortedFilteredStudents = useMemo(() => {
    return [...currentFilteredStudents].sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];
      if (sortConfig.key === "present_percentage") {
        aVal = parseFloat(aVal);
        bVal = parseFloat(bVal);
      }
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [currentFilteredStudents, sortConfig]);

  // --------------- HELPERS ---------------
  const getAttendanceStatus = (percentage) => {
    const p = parseFloat(percentage);
    if (p >= 75) return { label: "Good", color: "green" };
    if (p >= 50) return { label: "Average", color: "yellow" };
    return { label: "Poor", color: "red" };
  };

  const getAttendanceColor = (percentage) => {
    const p = parseFloat(percentage);
    if (p >= 75) return "text-green-600 dark:text-green-400";
    if (p >= 50) return "text-yellow-600 dark:text-yellow-400";
    return "text-red-600 dark:text-red-400";
  };

  const getAttendanceBarColor = (percentage) => {
    const p = parseFloat(percentage);
    if (p >= 75) return "bg-green-500";
    if (p >= 50) return "bg-yellow-500";
    return "bg-red-500";
  };

  const calculateStats = () => {
    if (!filteredStudents.length) return null;
    const presentClasses = filteredStudents.reduce((sum, s) => sum + (s.present || 0), 0);
    const totalClasses = filteredStudents.reduce((sum, s) => sum + (s.total_class || 0), 0);
    const overall = totalClasses > 0 ? (presentClasses / totalClasses) * 100 : 0;
    const good = filteredStudents.filter(s => parseFloat(s.present_percentage) >= 75).length;
    const average = filteredStudents.filter(s => {
      const p = parseFloat(s.present_percentage);
      return p >= 50 && p < 75;
    }).length;
    const poor = filteredStudents.filter(s => parseFloat(s.present_percentage) < 50).length;
    return {
      totalStudents: filteredStudents.length,
      totalClasses,
      overallAttendance: overall.toFixed(2) + "%",
      goodAttendance: good,
      averageAttendance: average,
      poorAttendance: poor,
      attendanceTrend: overall > 75 ? "up" : overall > 50 ? "stable" : "down",
    };
  };

  const stats = calculateStats();
  const summary = getSummaryData();

  // --------------- EXPORTS ---------------
  const handleExportToExcel = () => {
    if (!semester || !filteredStudents.length) {
      toast.error("No data to export");
      return;
    }
    try {
      const exportData = filteredStudents.map((student) => ({
        "Rank": student.rank || "",
        "Student ID": student.student_id,
        "Student Name": student.student_name,
        "College Roll": student.clg_roll || "",
        "Programme Name": student.programme_name || "",
        "Total Classes": student.total_class,
        Present: student.present,
        Absent: student.absent,
        "Attendance Percentage": student.present_percentage,
        Status: getAttendanceStatus(student.present_percentage).label,
        Semester: semester,
        "Date Range": fromDate && toDate ? `${fromDate} to ${toDate}` : "All",
      }));

      if (stats) {
        exportData.push({}, {
          "Student Name": "SUMMARY",
          "Total Students": stats.totalStudents,
          "Total Classes": stats.totalClasses,
          "Overall Attendance": stats.overallAttendance,
          "Good Attendance (≥75%)": stats.goodAttendance,
          "Average Attendance (50-74%)": stats.averageAttendance,
          "Poor Attendance (<50%)": stats.poorAttendance,
        });
      }

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, `Semester ${semester} Attendance`);
      ws['!cols'] = [
        { wch: 8 }, { wch: 12 }, { wch: 25 }, { wch: 18 }, { wch: 35 },
        { wch: 14 }, { wch: 10 }, { wch: 10 }, { wch: 18 }, { wch: 10 },
        { wch: 10 }, { wch: 25 },
      ];
      const fileName = `Semester_${semester}_Attendance_Report_${new Date().toISOString().split("T")[0]}.xlsx`;
      XLSX.writeFile(wb, fileName);
      toast.success(`Report exported as ${fileName}`);
    } catch (err) {
      console.error("Export error:", err);
      toast.error("Failed to export report");
    }
  };

  const handleExportToCSV = () => {
    if (!semester || !filteredStudents.length) {
      toast.error("No data to export");
      return;
    }
    try {
      const header = "Rank,Student ID,Student Name,College Roll,Programme Name,Total Classes,Present,Absent,Attendance Percentage,Status,Semester,Date Range";
      const rows = filteredStudents.map(s => {
        const status = getAttendanceStatus(s.present_percentage).label;
        const range = fromDate && toDate ? `${fromDate} to ${toDate}` : "All";
        return `${s.rank || ""},${s.student_id},"${s.student_name}",${s.clg_roll || ""},"${s.programme_name || ""}",${s.total_class},${s.present},${s.absent},${s.present_percentage},${status},${semester},"${range}"`;
      });
      if (stats) {
        rows.push("");
        rows.push(`"SUMMARY",,,,,,,,,,,`);
        rows.push(`"Total Students",${stats.totalStudents}`);
        rows.push(`"Total Classes",${stats.totalClasses}`);
        rows.push(`"Overall Attendance","${stats.overallAttendance}"`);
        rows.push(`"Good Attendance (≥75%)",${stats.goodAttendance}`);
        rows.push(`"Average Attendance (50-74%)",${stats.averageAttendance}`);
        rows.push(`"Poor Attendance (<50%)",${stats.poorAttendance}`);
      }
      const csvContent = [header, ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Semester_${semester}_Attendance_Report_${new Date().toISOString().split("T")[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV exported successfully");
    } catch (err) {
      console.error("CSV export error:", err);
      toast.error("Failed to export CSV");
    }
  };

  const handlePrint = () => {
    if (!semester) {
      toast.error("Please select a semester first");
      return;
    }
    window.print();
  };

  // --------------- RENDER ---------------
  const students = sortedFilteredStudents;
  const pagination = filteredPagination;

  return (
    <div className="p-6 space-y-6">
      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">
            Semester Wise Attendance Report
          </h1>
          <p className="text-gray-600 dark:text-gray-300 mt-1">
            Analyze attendance data for each semester with optional date range
          </p>
        </div>
        <div className="flex items-center gap-3">
          {/* Export dropdown */}
          <div className="relative group">
            <button
              disabled={!semester || !filteredStudents.length}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-lg ${
                semester && filteredStudents.length
                  ? "bg-green-600 hover:bg-green-700 text-white"
                  : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
              }`}
            >
              <FiDownload className="w-4 h-4" />
              <span className="hidden sm:inline">Export</span>
            </button>
            <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-10">
              <button
                onClick={handleExportToExcel}
                disabled={!semester || !filteredStudents.length}
                className="w-full text-left px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 text-gray-700 dark:text-gray-300"
              >
                <FiFileText className="w-4 h-4" /> Export as Excel
              </button>
              <button
                onClick={handleExportToCSV}
                disabled={!semester || !filteredStudents.length}
                className="w-full text-left px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 text-gray-700 dark:text-gray-300"
              >
                <FiFileText className="w-4 h-4" /> Export as CSV
              </button>
            </div>
          </div>
          <button
            onClick={handlePrint}
            disabled={!semester}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-lg ${
              semester
                ? "bg-blue-600 hover:bg-blue-700 text-white"
                : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
            }`}
          >
            <FiPrinter className="w-4 h-4" />
            <span className="hidden sm:inline">Print</span>
          </button>
        </div>
      </div>

      {/* FILTERS CARD */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-3 mb-6">
          <FiFilter className="w-6 h-6 text-purple-600 dark:text-purple-400" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Semester Selection</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Semester */}
          <div className="relative group">
            <div className="absolute left-4 top-4 text-gray-400"><FiBook className="w-5 h-5" /></div>
            <select
              className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 focus:outline-none transition-all duration-300 group-hover:border-purple-400"
              value={semester}
              onChange={(e) => setSemester(e.target.value)}
            >
              {semesterOptions.map((opt) => (
                <option key={opt.value} value={opt.value} disabled={opt.disabled}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          {/* Class Type */}
          <div className="relative group">
            <div className="absolute left-4 top-4 text-gray-400"><FiFilter className="w-5 h-5" /></div>
            <select
              className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 focus:outline-none transition-all duration-300 group-hover:border-purple-400"
              value={classType}
              onChange={(e) => setClassType(e.target.value)}
            >
              <option value="">All Class Types</option>
              <option value="Theory">Theory</option>
              <option value="Practical">Practical</option>
              <option value="Tutorial">Tutorial</option>
            </select>
          </div>

          {/* Date Range */}
          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="relative group">
              <div className="absolute left-4 top-4 text-gray-400"><FiCalendar className="w-5 h-5" /></div>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 focus:outline-none transition-all duration-300 group-hover:border-purple-400"
                placeholder="From Date"
              />
            </div>
            <div className="relative group">
              <div className="absolute left-4 top-4 text-gray-400"><FiCalendar className="w-5 h-5" /></div>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 focus:outline-none transition-all duration-300 group-hover:border-purple-400"
                placeholder="To Date"
              />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mt-4">
          <button
            onClick={handleSearch}
            disabled={loading || !semester}
            className={`flex-1 flex items-center justify-center gap-2 font-semibold py-3 px-6 rounded-xl transition-all duration-300 hover:shadow-lg ${
              semester
                ? "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white"
                : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
            }`}
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>Loading...</span>
              </>
            ) : (
              <>
                <FiSearch className="w-5 h-5" />
                <span>Generate Report</span>
              </>
            )}
          </button>
          <button
            onClick={handleReset}
            className="px-4 py-3 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-medium rounded-xl transition-all duration-300"
          >
            Reset
          </button>
        </div>
      </div>

      {/* Active Filters Indicator */}
      {(fromDate || toDate) && semester && (
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-3 text-sm text-blue-800 dark:text-blue-200 flex items-center gap-2">
          <FiCalendar className="w-4 h-4" />
          <span>
            Showing attendance for Semester {semester} from{" "}
            <strong>{fromDate || "beginning"}</strong> to{" "}
            <strong>{toDate || "end"}</strong>
          </span>
        </div>
      )}

      {/* Student Search */}
      {semester && getStudentsData().length > 0 && (
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700">
          <div className="relative group">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"><FiSearch className="w-5 h-5" /></div>
            <input
              type="text"
              placeholder="Search by Name, ID, College Roll, or Programme..."
              value={studentSearchTerm}
              onChange={(e) => setStudentSearchTerm(e.target.value)}
              className="w-full pl-12 pr-12 py-3 rounded-xl border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 focus:outline-none text-base"
              autoComplete="off"
            />
            {studentSearchTerm && (
              <button
                onClick={() => {
                  setStudentSearchTerm("");
                  setDebouncedStudentSearchTerm("");
                }}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                <FiX className="w-5 h-5" />
              </button>
            )}
          </div>
          {debouncedStudentSearchTerm && filteredStudents.length === 0 && getStudentsData().length > 0 && (
            <p className="mt-2 text-sm text-amber-600 dark:text-amber-400 flex items-center gap-1">
              <FiAlertCircle className="w-4 h-4" />
              No students found matching "{debouncedStudentSearchTerm}"
            </p>
          )}
          {debouncedStudentSearchTerm && filteredStudents.length > 0 && (
            <p className="mt-2 text-sm text-green-600 dark:text-green-400">
              Found {filteredStudents.length} student{filteredStudents.length !== 1 ? "s" : ""} matching "{debouncedStudentSearchTerm}"
            </p>
          )}
        </div>
      )}

      {/* Statistics Cards */}
      {semester && stats && (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-2xl shadow p-6 border border-purple-200 dark:border-purple-800">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 dark:text-gray-400">Overall Attendance</p>
                <p className="text-3xl font-bold text-gray-900 dark:text-white mt-2">{stats.overallAttendance}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className={`text-sm font-medium ${
                    stats.attendanceTrend === "up" ? "text-green-600 dark:text-green-400" :
                    stats.attendanceTrend === "stable" ? "text-yellow-600 dark:text-yellow-400" :
                    "text-red-600 dark:text-red-400"
                  }`}>
                    {stats.attendanceTrend === "up" ? "Good" : stats.attendanceTrend === "stable" ? "Average" : "Needs Improvement"}
                  </span>
                  {stats.attendanceTrend === "up" ? <FiTrendingUp className="w-4 h-4 text-green-500" /> :
                   stats.attendanceTrend === "stable" ? <FiBarChart2 className="w-4 h-4 text-yellow-500" /> :
                   <FiTrendingDown className="w-4 h-4 text-red-500" />}
                </div>
              </div>
              <div className="p-3 bg-white dark:bg-gray-800 rounded-full shadow">
                <FiBarChart2 className="w-8 h-8 text-purple-600 dark:text-purple-400" />
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-purple-200 dark:border-purple-800">
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Based on {stats.totalStudents} students across {stats.totalClasses} classes
              </p>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 dark:text-gray-400">Total Students</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{stats.totalStudents}</p>
              </div>
              <div className="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-full">
                <FiUsers className="w-6 h-6 text-blue-600 dark:text-blue-400" />
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 dark:text-gray-400">Good Attendance (≥75%)</p>
                <p className="text-2xl font-bold text-green-600 dark:text-green-400 mt-1">{stats.goodAttendance}</p>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  {stats.totalStudents > 0 ? ((stats.goodAttendance / stats.totalStudents) * 100).toFixed(1) : 0}% of total
                </p>
              </div>
              <div className="p-3 bg-green-100 dark:bg-green-900/30 rounded-full">
                <FiCheckCircle className="w-6 h-6 text-green-600 dark:text-green-400" />
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6 border border-gray-200 dark:border-gray-700">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 dark:text-gray-400">Poor Attendance (&lt;50%)</p>
                <p className="text-2xl font-bold text-red-600 dark:text-red-400 mt-1">{stats.poorAttendance}</p>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  {stats.totalStudents > 0 ? ((stats.poorAttendance / stats.totalStudents) * 100).toFixed(1) : 0}% of total
                </p>
              </div>
              <div className="p-3 bg-red-100 dark:bg-red-900/30 rounded-full">
                <FiXCircle className="w-6 h-6 text-red-600 dark:text-red-400" />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Semester Info Card */}
      {semester && semesterSummary && (
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                Semester {semester} Attendance Summary
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mt-1">
                Detailed attendance analysis for all students
              </p>
            </div>
            <div className="flex items-center gap-4">
              <div className="bg-gray-100 dark:bg-gray-900 px-4 py-2 rounded-lg">
                <div className="text-center">
                  <div className="text-2xl font-bold text-purple-600 dark:text-purple-400">
                    {summary?.total_class || 0}
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">Total Classes</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* RESULTS TABLE */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Student Attendance Details</h3>
              <div className="flex items-center gap-4 mt-2 text-sm">
                <button onClick={() => handleSort("student_name")} className="flex items-center gap-1 text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400">
                  Sort by Name {sortConfig.key === "student_name" && (sortConfig.direction === "asc" ? <FiChevronUp className="w-4 h-4" /> : <FiChevronDown className="w-4 h-4" />)}
                </button>
                <button onClick={() => handleSort("present_percentage")} className="flex items-center gap-1 text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400">
                  Sort by Attendance {sortConfig.key === "present_percentage" && (sortConfig.direction === "asc" ? <FiChevronUp className="w-4 h-4" /> : <FiChevronDown className="w-4 h-4" />)}
                </button>
              </div>
            </div>
            {pagination.totalPages > 0 && (
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600 dark:text-gray-400">Show</span>
                  <select
                    value={limit}
                    onChange={(e) => handleLimitChange(Number(e.target.value))}
                    className="px-2 py-1 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm"
                  >
                    {[5,10,25,50,100,500,1000,2000].map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                  <span className="text-sm text-gray-600 dark:text-gray-400">entries</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-900/50">
              <tr>
                <th className="py-4 px-6 text-left text-sm font-semibold text-gray-900 dark:text-white">Student Details</th>
                <th className="py-4 px-6 text-left text-sm font-semibold text-gray-900 dark:text-white">Programme</th>
                <th className="py-4 px-6 text-center text-sm font-semibold text-gray-900 dark:text-white">Attendance Summary</th>
                <th className="py-4 px-6 text-center text-sm font-semibold text-gray-900 dark:text-white">Class Type</th>
                <th className="py-4 px-6 text-center text-sm font-semibold text-gray-900 dark:text-white">Remarks</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
              {loading ? (
                <tr>
                  <td colSpan="5" className="py-12 text-center">
                    <div className="flex flex-col items-center gap-3">
                      <div className="w-12 h-12 border-4 border-purple-200 dark:border-purple-800 border-t-purple-600 dark:border-t-purple-400 rounded-full animate-spin"></div>
                      <p className="text-gray-600 dark:text-gray-400">Loading semester data...</p>
                    </div>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="5" className="py-12 text-center">
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-3 bg-red-100 dark:bg-red-900/20 rounded-full"><FiXCircle className="w-8 h-8 text-red-600 dark:text-red-400" /></div>
                      <p className="text-red-600 dark:text-red-400 font-medium">{error}</p>
                      <button onClick={handleSearch} className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg">Try Again</button>
                    </div>
                  </td>
                </tr>
              ) : !semester ? (
                <tr>
                  <td colSpan="5" className="py-16 text-center">
                    <div className="flex flex-col items-center gap-4">
                      <div className="p-4 bg-purple-100 dark:bg-purple-900/20 rounded-full"><FiBook className="w-12 h-12 text-purple-600 dark:text-purple-400" /></div>
                      <p className="text-lg font-medium text-gray-900 dark:text-white">Select a Semester</p>
                      <p className="text-gray-600 dark:text-gray-400">Please select a semester and click "Generate Report"</p>
                    </div>
                  </td>
                </tr>
              ) : students.length > 0 ? (
                students.map((student, idx) => {
                  const status = getAttendanceStatus(student.present_percentage);
                  const attColor = getAttendanceColor(student.present_percentage);
                  const barColor = getAttendanceBarColor(student.present_percentage);
                  return (
                    <tr key={student.student_id || idx} className="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors duration-200">
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-gradient-to-r from-purple-100 to-pink-100 dark:from-purple-900/30 dark:to-pink-900/30 rounded-full flex items-center justify-center">
                            <FiUser className="w-5 h-5 text-purple-600 dark:text-purple-400" />
                          </div>
                          <div>
                            <p className="font-medium text-gray-900 dark:text-white">{student.student_name}</p>
                            <p className="text-sm text-gray-500 dark:text-gray-400">ID: {student.student_id} | Roll: {student.clg_roll || "N/A"}</p>
                            {student.rank && <p className="text-xs text-gray-400 dark:text-gray-500">Rank: #{student.rank}</p>}
                          </div>
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-2">
                          <FiBriefcase className="w-4 h-4 text-gray-400 dark:text-gray-500" />
                          <span className="text-sm text-gray-700 dark:text-gray-300">{student.programme_name || "N/A"}</span>
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="flex flex-col gap-3">
                          <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Attendance</span>
                            <span className={`text-lg font-bold ${attColor}`}>{student.present_percentage}</span>
                          </div>
                          <div className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                            <div className={`h-full rounded-full ${barColor}`} style={{ width: `${Math.min(parseFloat(student.present_percentage), 100)}%` }}></div>
                          </div>
                          <div className="grid grid-cols-3 gap-2 text-center">
                            <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded"><p className="text-sm text-gray-600 dark:text-gray-400">Total</p><p className="font-bold text-gray-900 dark:text-white">{student.total_class}</p></div>
                            <div className="p-2 bg-green-50 dark:bg-green-900/20 rounded"><p className="text-sm text-gray-600 dark:text-gray-400">Present</p><p className="font-bold text-green-600 dark:text-green-400">{student.present}</p></div>
                            <div className="p-2 bg-red-50 dark:bg-red-900/20 rounded"><p className="text-sm text-gray-600 dark:text-gray-400">Absent</p><p className="font-bold text-red-600 dark:text-red-400">{student.absent}</p></div>
                          </div>
                        </div>
                      </td>
                      <td className="py-4 px-6 text-center">
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                          summary?.class_type?.toLowerCase() === "theory" ? "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300" :
                          summary?.class_type?.toLowerCase() === "practical" ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300" :
                          summary?.class_type?.toLowerCase() === "tutorial" ? "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300" :
                          "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300"
                        }`}>
                          {summary?.class_type ? summary.class_type.charAt(0).toUpperCase() + summary.class_type.slice(1).toLowerCase() : "N/A"}
                        </span>
                      </td>
                      <td className="py-4 px-6 text-center">
                        <div className="flex flex-col items-center gap-2">
                          <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                            parseFloat(student.present_percentage) >= 60
                              ? "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300"
                              : "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300"
                          }`}>
                            {parseFloat(student.present_percentage) >= 60 ? "Allowed" : "Not Allowed"}
                          </span>
                          <div className="flex items-center gap-1">
                            {parseFloat(student.present_percentage) >= 60 ? <FiCheckCircle className="w-4 h-4 text-green-500" /> : <FiXCircle className="w-4 h-4 text-red-500" />}
                            <span className="text-xs text-gray-500 dark:text-gray-400">
                              {parseFloat(student.present_percentage) >= 60 ? "Attendance requirement met" : "Below 60% requirement"}
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="py-16 text-center">
                    <div className="flex flex-col items-center gap-4">
                      <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-full"><FiUsers className="w-12 h-12 text-gray-400 dark:text-gray-600" /></div>
                      <p className="text-lg font-medium text-gray-900 dark:text-white">
                        {debouncedStudentSearchTerm ? "No matching students found" : "No student records found"}
                      </p>
                      <p className="text-gray-600 dark:text-gray-400">
                        {debouncedStudentSearchTerm ? `No students found matching "${debouncedStudentSearchTerm}"` : `No attendance data available for Semester ${semester}`}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {pagination.totalPages > 0 && (
          <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="text-sm text-gray-500 dark:text-gray-400">
                Showing {(currentPage - 1) * limit + 1} to {Math.min(currentPage * limit, pagination.total || 0)} of {pagination.total || 0} records
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`flex items-center gap-1 px-3 py-2 rounded-lg transition ${
                    currentPage === 1 ? "bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed" : "bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300"
                  }`}
                >
                  <FiChevronLeft /> Previous
                </button>
                <div className="flex items-center gap-1">
                  {Array.from({ length: Math.min(5, pagination.totalPages || 1) }, (_, i) => {
                    let pageNum;
                    if (pagination.totalPages <= 5) pageNum = i + 1;
                    else if (currentPage <= 3) pageNum = i + 1;
                    else if (currentPage >= pagination.totalPages - 2) pageNum = pagination.totalPages - 4 + i;
                    else pageNum = currentPage - 2 + i;
                    if (pageNum < 1 || pageNum > pagination.totalPages) return null;
                    return (
                      <button
                        key={pageNum}
                        onClick={() => handlePageChange(pageNum)}
                        className={`w-10 h-10 rounded-lg transition ${
                          currentPage === pageNum
                            ? "bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg"
                            : "bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300"
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                </div>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === pagination.totalPages}
                  className={`flex items-center gap-1 px-3 py-2 rounded-lg transition ${
                    currentPage === pagination.totalPages ? "bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed" : "bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300"
                  }`}
                >
                  Next <FiChevronRight />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SemesterWiseReports;